export default __webpack_public_path__ + "static/media/vauxhall_movano.74e6ae65.png";